import { lazy } from 'react';

const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));

export const ResetPasswordEntry = () => <ResetPasswordPage />;
